export const componentOptions = [
	{
		name: "battery",
		urlName: "battery",
		method: "setMasterBattery",
		validation: [],
		enabled: true,
		isMaster: true,
	},
	{
		name: "wind sensor",
		urlName: "wind-sensor",
		method: "setMasterWindSensor",
		validation: [],
		enabled: true,
		isMaster: true,
	},
	{
		name: "snow sensor",
		urlName: "snow-sensor",
		method: "setMasterSnowSensor",
		validation: [],
		enabled: true,
		isMaster: true,
	},
	{
		name: "enclosure",
		urlName: "board",
		method: "setMasterEnclosure",
		validation: [],
		enabled: true,
		isMaster: true,
	},
	{
		name: "enclosure",
		urlName: "board",
		method: "setNodeEnclosure",
		validation: [],
		enabled: false,
		isMaster: false,
	},
	{
		name: "actuator",
		urlName: "actuator",
		method: "setNodeActuator",
		validation: [],
		enabled: true,
		isMaster: false,
	},
	{
		name: "charging panel",
		urlName: "charging-panel",
		method: "setNodeChargingPanel",
		validation: [],
		enabled: true,
		isMaster: false,
	},
	{
		name: "battery",
		urlName: "battery",
		method: "setNodeBattery",
		validation: [],
		enabled: true,
		isMaster: false,
	},
]
